<template>
  <div class="desulphurization" id="desulphurization">
    <div class="titleLine">
      <div class="home_number num" v-if="styleType=='typeDark'">{{allCount}}</div>
      <div class="home_time time" v-if="styleType=='typeDark'">
        {{now_time}}
      </div>
    </div>
    <div class="desContent">
      <div class="desMain">
        <el-carousel :autoplay="true" :interval="10000" arrow="always" height="180px" @change="change" :initial-index="0" trigger="click">
          <el-carousel-item v-for="(a,i) in desData" :key="i">
            <div class="change">
              <div class="desName">
                {{a.deviceName}}
              </div>
              <el-carousel :autoplay="false" :interval="5000" arrow="never" height="150px" @change="change" :initial-index="0" trigger="click">
                <el-carousel-item v-for="(b, j) in cardNum1(a.value)" :key="j">
                  <ul>
                    <li v-for="(c, k) in b" :key="k">
                      <div class="liNum number" :class="'liNum'+k">{{c.signalValue}}</div>
                      <div class="liName">{{c.signalName}}({{c.signalUnit}})</div>
                    </li>
                  </ul>
                </el-carousel-item>
              </el-carousel>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { dateFormat } from "@/utils/tools.js";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  props: ["matrix", "x", "y"],
  data() {
    //这里存放数据
    return {
      pageInfo: 'desulphurization.vue',
      computedName: '脱硫脱硝监测数据组件',
      now_time: "",
      contain: "",
      customerId: this.$store.state.customerId,
      desData: [],
      list: [],
      deviceName: "",
      allCount: 0,
      timer: null,
      styleType: "",
    };
  },
  //计算属性 类似于data概念
  computed: {
    cardNum1() {
      return function (a) {
        let arr = [];
        let len = a.length;
        let len_ = Math.ceil(len / 6);
        for (let i = 0; i < len_; i++) {
          let tmp = [];
          let max = (i + 1) * 6 > len ? len : (i + 1) * 6;
          for (let j = i * 6; j < max; j++) {
            tmp.push(a[j]);
          }
          arr.push(tmp);
        }
        return arr;
      };
    },
    curStyleTypeVal() {
      return this.$store.state.styleType;
    },
  },
  //监控data中的数据变化
  watch: {
    curStyleTypeVal: {
      handler(newVal, oldVal) {
        this.styleType = newVal;
        this.typeChange();
      },
      deep: true,
    },
  },
  created() {
    this.styleType = this.$store.state.styleType;
  },
  unmounted() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  },
  mounted() {
    let that = this;
    let w = $(that.$refs.desulphurization).outerWidth();
    let h = $(that.$refs.desulphurization).outerHeight();
    that.$emit("componentInit", {
      w: w,
      h: h,
      matrixType: that.matrix,
      x: that.x,
      y: that.y,
    });

    this.getData();
    this.typeChange();
  },
  //方法集合
  methods: {
    typeChange() {
      if (this.styleType == "typeGreen") {
        //  this.$nextTick(()=>{
        //  })
      }
    },
    change(e) {},
    async getData() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.now_time = dateFormat("YYYY-mm-dd HH:MM", new Date());
      let findTltxList = CONFIG.requestName + this.$apiOpt.findTltxList;
      let data = await this.$apiUtils.get(findTltxList, {
        customerId: this.customerId,
      });
      //这有个BUG
      if (data.length) {
        data.forEach((_) => {
          _.value = _.value.slice(0, 6);
        });
        this.desData = data;
        this.allCount = data.length;
        this.$nextTick(() => {
         console.log('点一下')
          $(".desContent .desMain .el-icon-arrow-right")[0].click();
        });
      }
      this.timer = setTimeout(() => {
        this.getData();
      }, 5 * 60 * 1000);
    },
  },
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped='scoped'>
.desulphurization {
  width: 600px;
  height: 250px;
  .titleLine {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    height: 24px;
    .num {
      margin-right: 190px;
    }
    .time {
    }
  }
  .desContent {
    margin-top: 4px;
    display: flex;
    align-items: center;
    position: relative;
    height: 186px;
    .desMain {
      // height: 100%;
      // width: 100%;
      @include bg-box(100%, 100%, "desBg.png");
      ul {
        width: 100%;
        height: 100%;
        padding: 10px;
        display: flex;
        flex-flow: row wrap;
        justify-content: space-between;
        li {
          text-align: center;
          width: 33%;
          padding-top: 8px;
          .liNum {
            font-size: 28px;
            text-shadow: 1px 1px 3px rgba(153, 245, 255, 0.65);
            height: 28px;
            color: #ffffff;
            line-height: 28px;
            margin-bottom: 2px;
          }
          .liName {
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            height: 16px;
            font-size: 14px;
            color: #c8d8ff;
            line-height: 16px;
          }
        }
      }
    }
  }
  .desName {
    height: 32px;
    font-size: 16px;
    color: #f5a623;
    line-height: 32px;
    text-align: center;
  }
}
</style>
<style >
.desulphurization .el-carousel__arrow--left {
  left: 30px !important;
  top: 16px !important;
  background: none !important;
  color: rgba(245, 166, 35, 1);
}
.desulphurization .el-carousel__arrow--right {
  right: 30px !important;
  top: 16px !important;
  background: none !important;
  color: rgba(245, 166, 35, 1);
}
.desulphurization .el-carousel__indicators--horizontal {
  /* display: none; */
}
.change .el-carousel__indicators {
  display: none !important;
}

.desulphurization .liNum1 {
  color: rgba(183, 255, 197, 1) !important;
}
.desulphurization .liNum4 {
  color: rgba(183, 255, 197, 1) !important;
}
.desulphurization .el-carousel {
  overflow: hidden;
}
.desMain .el-carousel__indicators {
  width: 100%;
  display: flex;
  bottom: -10px;
  padding: 0 10px;
}
.desMain .el-carousel__indicators li {
  width: 100%;
  padding: 12px 0px;
}
.desMain .el-carousel__indicators li button {
  width: 100%;
  height: 5px;
  background-color: rgba(245, 166, 35, 1);
}
.desMain .el-carousel__button {
  background-color: rgba(245, 166, 35, 1);
  opacity: 0.1 !important;
}
.desMain .is-active .el-carousel__button {
  opacity: 1 !important;
}
</style>
